import { GlButton } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { ROUTES } from '../../../constants';
export default {
    name: 'DesignPreviewCloseButton',
    components: {
        GlButton
    },
    ROUTES
};
